import {StyleSheet, ViewStyle} from 'react-native';

import {grayscale} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex' as any,
    alignItems: 'center',
  } as unknown as ViewStyle,
});

// For library overrides that can't be handled by StyleSheet
export const libraryOverrides = `
  /* Base TimePicker Styles */
  .web-time-picker-container .react-time-picker {
    display: inline-flex;
    position: relative;
    width: 100%;
    height: 100%;
    align-items: center;
  }
  .web-time-picker-container .react-time-picker,
  .web-time-picker-container .react-time-picker *,
  .web-time-picker-container .react-time-picker *:before,
  .web-time-picker-container .react-time-picker *:after {
    box-sizing: border-box;
  }
  .web-time-picker-container .react-time-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: none !important;
    height: 100% !important;
    align-items: center !important;
    padding: 0 16px !important;
  }
  .web-time-picker-container .react-time-picker__inputGroup {
    min-width: 0 !important;
    flex-grow: 1;
    padding: 0;
    display: flex;
    align-items: center;
    font-size: 16px !important;
    color: ${codGray} !important;
    font-family: inherit;
  }
  .web-time-picker-container .react-time-picker__inputGroup__divider {
    padding: 1px 0;
    color: ${codGray};
  }
  .web-time-picker-container .react-time-picker__inputGroup__input {
    min-width: 0.54em;
    height: 100%;
    position: relative;
    padding: 0 1px;
    border: 0;
    background: none;
    color: currentColor;
    font: inherit;
    box-sizing: content-box;
    appearance: textfield;
    outline: none;
    text-align: center;
  }
  .web-time-picker-container .react-time-picker__inputGroup__input::-webkit-outer-spin-button,
  .web-time-picker-container .react-time-picker__inputGroup__input::-webkit-inner-spin-button {
    appearance: none;
    margin: 0;
  }
  .web-time-picker-container .react-time-picker__inputGroup__amPm {
    font: inherit;
    appearance: none;
    border: none;
    background: transparent;
    padding: 0 4px;
    outline: none;
    color: inherit;
    cursor: pointer;
  }
  .web-time-picker-container .react-time-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: ${grayscale};
  }
  .web-time-picker-container .react-time-picker__button svg {
    width: 20px;
    height: 20px;
    stroke: currentColor;
    fill: none;
  }
  .web-time-picker-container .react-time-picker__button:enabled:hover {
    color: ${codGray};
  }

  /* Hide the Clock Popup */
  .react-time-picker__clock {
    display: none !important;
  }
`;
